<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Admin',
  data: () => ({
  }),
  mounted() {
  },
  methods: {
  },
};
</script>

<style>

</style>
